<div class="service-calendar-dialog">
  <h1 id="modal-heading" class="mat-display-small">
    Select a service
    <span (click)="closeDialog()">
      <mat-icon svgIcon="close_icon"></mat-icon>
    </span>
  </h1>
  <div class="service-calendar-dialog_services">
    <div class="quick-booking-picker">
      <div class="swiper-custom-prev quick-booking-prev" [class.swiper-button-disabled]="!hasData"></div>

      <swiper-container class="swiper-container-quick-booking" direction="horizontal" slides-per-view="3" space-between="15"
        navigation='{ "nextEl": ".quick-booking-next", "prevEl": ".quick-booking-prev" }'>
        @for (thumbnailCard of thumbnailCards; track thumbnailCard) {
          <swiper-slide>
            <app-thumbnail-icon-card (click)="viewService(thumbnailCard.cardText, 'quick booking', thumbnailCard.cardText)"
              [thumbnail]="thumbnailCard.cardImage" [text]="thumbnailCard.cardText" size="card">
            </app-thumbnail-icon-card>
          </swiper-slide>
        }

        @if (!hasData) {
          @for (i of [1,2,3]; track i) {
            <swiper-slide>
              <div class="skeleton-card">
                <mat-spinner color="primary" diameter="30"></mat-spinner>
              </div>
            </swiper-slide>
          }
        }
      </swiper-container>

      <div class="swiper-custom-next quick-booking-next" [class.swiper-button-disabled]="!hasData"></div>
    </div>
  </div>
</div>